import React from 'react';
import BookInfoForm from 'component/admin/bookInfoForm';
import Swal from 'sweetalert2';
import { updateBook } from 'services/admin/bookService';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { getBookByID } from 'services/user/bookService';
import { PacmanLoader } from 'react-spinners';

const UpdateBook = () => {
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem("token")
    const location = useLocation();
    const { bookID } = location.state; // id truyyền từ bookInfoForm á
    const [bookDetails, setBookDetails] = useState(null);

    // lấy sách từ id được lấy từ bookInfoForm
    useEffect(() => {
        const fetchBookDetails = async () => {
            setIsLoading(true)
            try {
                const response = await getBookByID(bookID);
                setBookDetails(response.data);
            } 
            catch (error) {
                console.log("fetchBookDetails", error)
            }
            finally {
                setIsLoading(false)
            }
        };
        window.scrollTo(0, 0);
    
        fetchBookDetails();
      }, [bookID]);

    const handleUpdateBook = async (formData) => {
        setIsLoading(true)
        try {
            const response = await updateBook(token, formData)
            if (response.data.message === "Book has been updated!") {
                Swal.fire({
                    title: "Chỉnh sửa thành công!",
                    text: `Sách của bạn đã được cập nhật!.`,
                    icon: "success"
                });
            }
            else {
                Swal.fire({
                    title: "Lỗi!",
                    text: `Chỉnh sửa sách không thành công!.`,
                    icon: "error"
                });
            }
        } 
        catch (error) {
            console.log("Update book: ", error)
            Swal.fire({
                title: "Lỗi!",
                text: `Chỉnh sửa sách không thành công!.`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            <BookInfoForm onSubmit={handleUpdateBook} book={bookDetails}/>
            
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default UpdateBook;